import { render, staticRenderFns } from "./templateConfiguration.vue?vue&type=template&id=0cf2a45a&scoped=true&"
import script from "./templateConfiguration.vue?vue&type=script&lang=js&"
export * from "./templateConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./templateConfiguration.vue?vue&type=style&index=0&id=0cf2a45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf2a45a",
  null
  
)

export default component.exports